
<template>
  <div>
    <div class="customer-body">
      <div class="customer-item service-box" @click="enterCustomer">
        <i class="customer-icon"></i>
        <span>在线客服</span>
      </div>
      <div class="customer-long">
        <div class="customer-item">
          <i class="customer-icon customer-public"></i>
          <span>微信公众号</span>
          <div class="customer-qr">
            <div class="customer-arrow"></div>
            <img class="customer-img" :src="webSite.wechat_public">
            <img class="customer-scan" src="../../assets/image/footer_app_scan.png">
          </div>
        </div>
        <div class="customer-item" style="margin-right: 0;" @click="enterCustomer">
          <i class="customer-icon customer-service"></i>
          <span>人工充值客服</span>
        </div>
      </div>
      <div class="customer-long"> 
        <div class="customer-item" @click="enterApk">
          <i class="customer-icon customer-app"></i>
          <span>{{customerAppName}}</span>
          <div class="customer-qr">
            <div class="customer-arrow"></div>
            <img class="customer-img" :src="webSite.apk_download">
            <img class="customer-scan" src="../../assets/image/footer_app_scan.png">
          </div>
        </div>
        <div class="customer-item" style="margin-right: 0;"  @click="enterQuestion(3);">
          <i class="customer-icon customer-help"></i>
          <span>自助申请</span>
        </div>
      </div>
      <div class="customer-big-long">
        <div class="customer-item" @click="enterMineRecharge">
          <i class="customer-icon customer-record"></i>
          <span>充值记录</span>
        </div>
        <div class="customer-item" @click="enterVip">
          <i class="customer-icon customer-vip"></i>
          <span>VIP会员俱乐部</span>
        </div>
        <div class="customer-item" style="margin-right: 0;"
         @click="enterQuestion(2);">
          <i class="customer-icon customer-question"></i>
          <span>常见问题</span>
        </div>
      </div>
      <div class="customer-big-long">
        <div class="customer-item customer-small" @click="enterSkip(3);">
          <span>用户协议</span>
        </div>
        <div class="customer-item customer-small" @click="enterSkip(2);">
          <span>隐私协议</span>
        </div>
        <div class="customer-item customer-small" @click="enterMineCertify">
          <span>实名认证</span>
        </div>
        <div class="customer-item customer-small" @click="enterSkip(1);">
          <span>未成年人家长监护</span>
        </div>
        <div class="customer-item" style="margin-right: 0;" v-if="!showTrueAndFalse"
         @click="enterCertify">
          <i class="customer-icon customer-false"></i>
          <span>真假客服认证</span>
        </div> 
        <div class="customer-item" style="margin-right: 0;" v-if="showTrueAndFalse">
          <div class="customer-line">
            <input placeholder="请输入客服QQ号" type="text" v-model="certifyText" class="customer-input">
            <div class="customer-button" @click="isCertify">验一验</div>
          </div>
          <div class="customer-span" v-if="showCertifyType == 2">警惕,此QQ不是101游戏官方客服!!</div> 
          <div class="customer-span" v-if="showCertifyType == 1" style="color: green;">经验证为101游戏官方客服</div> 
        </div>
      </div>  
    </div>
    <span class="customer-label">我的申述</span>
    <div class="customer-operate">
      <img src="../../assets/image/icon_customer_footer.jpg">
      <div class="customer-progress" v-if="!loginState">
        <span class="customer-h1">登陆后 查询申述进度</span>
        <span class="customer-login" @click="enterLogin">登陆</span>
        <span class="customer-register" @click="enterRegister">注册</span>
      </div>
      <div class="customer-progress" v-if="loginState">
        <span class="customer-examine">暂无申述</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "customerCenter",
  metaInfo(){
    return{
      title:"客服中心_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  asyncData({store,route}){
    return store.dispatch('initSeo',{store:store});
  },
  props: {
    loginState:{
      type:Boolean,
      default:false
    },
    customerAppName:{
      type:String,
      default:""
    },
  },
  data() {
    return {
      showTrueAndFalse:false,
      showFalseState:false,
      certifyText:"",
      showCertifyType:0,
      launchType:0 //0 没有跳转
    };
  },
  computed:{
    webSite(){
      return this.$store.state.home.webSite;
    },
    baseQrAddress(){
      return this.$store.state.constant.baseQrAddress;
    },
  },
  methods: {
    changeSuspendState(value){
      this.$emit('changeSuspendState',value);
    },
    changeSuspendType(value){
      this.$emit('changeSuspendType',value)
    },
    enterCertify(){
      this.showTrueAndFalse = true;
    },
    isCertify(){
      if(this.certifyText == "13619030" || this.certifyText == "26856800"){
        this.showCertifyType = 1;
      }else{
        this.showCertifyType = 2;
      }
    },
    enterQuestion(value){  
      document.body.scrollTo = document.documentElement.scrollTop = 0;
      this.$router.push({
        name:"question",
        params:{index:value}
      });
    },
    enterLogin(){
      this.changeSuspendType(0);
      this.changeSuspendState(true);
    },
    enterRegister(){
      this.changeSuspendType(1);
      this.changeSuspendState(true);
    },
    enterSkip(value){
      if(value == 1){
        window.open(this.$router.resolve({name:'tutelage'}).href,"_blank");
      }else if(value == 2){
        window.open(this.$router.resolve({name:'protocol'}).href,"_blank");
      }else if(value == 3){
        window.open(this.$router.resolve({name:'privacy'}).href,"_blank");
      }
    },
    enterVip(){
      window.open(this.$router.resolve({name:'vip'}).href,"_blank");
    },
    enterCustomer(){
      window.open(this.webSite.one_qq_url,'_blank');
    },
    enterApk(){
      this.$router.push({name:'apkDownload'});
    },
    enterMineRecharge(){
      if(this.loginState){
        window.open(this.$router.resolve({name:"mineRecharge"}).href,"_blank");
      }else{
        this.launchType = 2;
        this.enterLogin();
      }
    },
    enterMineCertify(){
      if(this.loginState){
        window.open(this.$router.resolve({name:'mineCertify'}).href,"_blank");
      }else{
        this.launchType = 1;
        this.enterLogin();
      }
    }
  },
  watch:{
    loginState:function(value){
      if(value){
        if(this.launchType == 1){
          this.enterMineCertify();
        }else if(this.launchType == 2){
          this.enterMineRecharge();
        }
      }
    },
  }  
};
</script>
<style src="@/assets/css/customer_center.css" scoped></style>